module.exports = __webpack_public_path__ + "img/progress-6.dc93ac35.jpg";